// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18":"20974f16","44":"e793b261","416":"06d51d24","525":"d9467f8a","729":"95dd5318","955":"eafcea7a"}[chunkId] + ".js";
};